import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Form,
    Card,
    Modal,
    Alert,
} from "react-bootstrap";
import Select from "react-select";
import HeaderTwo from "../../components/HeaderTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import { Styles, FormStyles } from "./styles/Register2.js";
import { useHistory } from "react-router-dom";
import service from "../../services/service";
import swal from "sweetalert";
import ClientCaptcha from "react-client-captcha";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import UserService from "../../services/UserService";
import HomeOne from "../../HomeOne";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import moment from "moment";
import Webcam from "react-webcam";
import { CheckEmail } from "./CheckEmail";
import adminServices from "../../services/adminServices";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { RegisterType } from "./RegisterData";
import DataTable from "react-data-table-component";
import { BreadcrumbBox2 } from "../../components/common/Breadcrumb2";
import CryptoJS from "crypto-js";

const Register2 = () => {

    const history = useHistory();

    const [selectedCard, setSelectedCard] = useState(null);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [firstModalLoading, setFirstModalLoading] = useState(false);
    const [secondModalLoading, setSecondModalLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [mobileNumber, setMobileNumber] = useState(null);
    const [rollNumber, setRollNumber] = useState(null);

    //////////////////////

    //ERROR STATES//
    const [firstNameError, setFirstNameError] = useState(null);
    const [lastNameError, setLastNameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [mobileNumberError, setMobileNumberError] = useState(null);
    const [rollError, setRollError] = useState(null);
    const [captchaInputError, setCaptchaInputError] = useState(null);
    const [otpError, setOtpError] = useState(null);
    ///////////////

    const [captchaHash, setCaptchaHash] = useState();
    const [captchaToken, setCaptchaToken] = useState();
    const [captchaKey, setCaptchaKey] = useState();
    const [captchaImage, setCaptchaImage] = useState("");

    const [captchaInput, setCaptchaInput] = useState("");
    const [OTP, setOTP] = useState(null);
    const [sendOTP, setSendOTP] = useState(false);
    const [collegeName, setCollegeName] = useState("");

    const [userDetails, setUserDetails] = useState([
        {
            email: "",
            firstName: "",
            lastName: "",
            rollNumber: "",
            collegeName: "",
        },
    ]);

    useEffect(() => {
        handleRefreshCaptcha();
    }, []);

    const handleCardClick = (value) => {
        if (value == 2) {
            encodeUrlHandler("chariot@cdac.in", value)
        }
        else {
            setSelectedCard(value);
            setShowEmailModal(true);
        }
    };

    const handleFirstNameChange = (e) => {
        setUserDetails({ ...userDetails, firstName: e.target.value });
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setUserDetails({ ...userDetails, lastName: e.target.value });
        setLastName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setUserDetails({ ...userDetails, email: e.target.value });
        setEmail(e.target.value);
    };

    const handleMobileNumberChange = (e) => {
        setUserDetails({ ...userDetails, mobile: e.target.value });
        setMobileNumber(e.target.value);
    };

    // const handleSelectionChange = (selectedOptions) => {
    //     setUserDetails({ ...userDetails, courses: selectedOptions });
    //     setSelectedOptions(selectedOptions);
    // };

    const handleCaptchaInputChange = (e) => {
        setCaptchaInput(e.target.value);
    };

    const handleCollegeNameChange = (e) => {
        setUserDetails({ ...userDetails, college: e.target.value });
        setCollegeName(e.target.value);
    };

    const handleRollNumberChange = (e) => {
        setUserDetails({ ...userDetails, rollNumber: e.target.value });
        setRollNumber(e.target.value);
    };

    const handleOTPChange = (e) => {
        setOTP(e.target.value);
    };

    const handleFirstNameBlur = () => {
        /////NAME VALID LOGIC
        if (firstName === "") {
            setFirstNameError("*Enter your First Name");
        }
        else if (firstName.length < 3) {
            setFirstNameError("*Must have at least 3 letters")
        }
        else if (!/^[A-Za-z]+$/.test(firstName)) {
            setFirstNameError("*First Name can only contain letters");
        }
        else {
            setFirstNameError(null);
        }
    };

    const handleLastNameBlur = () => {
        /////NAME VALID LOGIC
        if (lastName === "") {
            setLastNameError("*Enter your Last Name");
        }
        else if (lastName.length < 3) {
            setLastNameError("*Must have at least 3 letters")
        }
        else if (!/^[A-Za-z]+$/.test(lastName)) {
            setLastNameError("*Last Name can only contain letters");
        }
        else {
            setLastNameError(null);
        }
    };

    const handleEmailBlur = () => {
        if (!email) {
            setEmailError("*Please enter your email");
        } else if (!isValidEmail(email)) {
            setEmailError("*Please provide a valid email");
        } else {
            setEmailError(null)
        }
    };
    const isValidEmail = (email) => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        return emailRegex.test(email);
    };

    const handleMobileNumberBlur = () => {
        if (!mobileNumber) {
            setMobileNumberError("*Please enter your mobile number");
        } else if (mobileNumber.length !== 10) {
            setMobileNumberError("*Mobile number should be 10 digits long");
        } else if (!isValidNumber(mobileNumber)) {
            setMobileNumberError("*Please enter a valid number");
        } else {
            setMobileNumberError(null);
        }
    };

    // Helper function to validate number format
    const isValidNumber = (number) => {
        const numberRegex = /^\d+$/;
        return numberRegex.test(number);
    };

    const handleCollegeNameBlur = () => {
        /////COLLEGE NAME VAILD LOGIC

    };

    const handleRollNumberBlur = () => {
        /////ROll NUmber VAILD LOGIC
        if (!rollNumber) {
            setRollError("*Please enter your Roll number");
        } else {
            setRollError(null);
        }
    };

    const handleCaptchaBlur = () => {
        /////CAPTCHA VALID LOGIC
        if (!captchaInput) {
            setCaptchaInputError("*Please enter the Captcha Value");
        } else {
            setCaptchaInputError(null);
        }
    };

    const handleRefreshCaptcha = () => {
        service.getRegisterCaptcha().then((res) => {

            setCaptchaImage(res.data.captchaImage);
            setCaptchaHash(res.data.captchaHash);
            setCaptchaToken(res.data.captchaToken);
            setCaptchaKey(res.data.captchaKey);
        });
    };

    const handleOTPBlur = () => {
        if (!OTP) {
            setOtpError("*Please Enter the OTP sent to your email")
        }
        else {
            setOtpError(null);
        }
    }

    const handleSendOTP = () => {
        //SEND OTP LOGIC
        //IF Sucessfully send OTP then:
        setOtpLoading(true);
        const formData1 = new FormData();
        formData1.append("email", email);
        formData1.append("captchaHash", captchaHash);
        formData1.append("captchaInput", captchaInput);
        formData1.append("captchaToken", captchaToken);
        formData1.append("captchaKey", captchaKey);
        formData1.append("registrationType", selectedCard);

        service
            .registerEmail(formData1)
            .then((res) => {

                if (res.data) {
                    setOtpLoading(false);
                    setSendOTP(true);
                }
                else if (res.data == "") {
                    setSendOTP(false);
                    setOtpLoading(false);
                    setCaptchaInputError("Enter the correct captcha value!");
                }
            })
            .catch((err) => {
                setOtpLoading(false);

            });
    };

    const handleCloseEmailModal = () => {
        setShowEmailModal(false);
        setEmail("");
        setOTP("");
        setRollNumber("");
        setCaptchaInput("");

        setEmailError(null);
        setCaptchaInputError(null);
        setOtpError(null);
        setRollError(null);

        setSendOTP(false);
        setOtpLoading(false);
        setFirstModalLoading(false);

        handleRefreshCaptcha();
    };

    const handleCloseUserDetailModal = () => {
        setShowUserDetailModal(false);
        setFirstName("");
        setLastName("");
        setMobileNumber("");
        setEmail("");
        setOTP("");
        setCaptchaInput("");
        setRollNumber("");

        setFirstNameError(null);
        setLastNameError(null);
        setMobileNumberError(null);
        setEmailError(null);
        setCaptchaInputError(null);
        setOtpError(null);
        setRollError(null);

        setSendOTP(false);
        setOtpLoading(false);
        setSecondModalLoading(false);

        handleRefreshCaptcha();
    };

    const handleEmailRegister = async () => {
        setFirstModalLoading(true);

        service.registerationtokenVerification(email, OTP)
            .then(res => {

                if (res.data === "Success") {
                    setFirstModalLoading(false);
                    setShowUserDetailModal(true);
                    setShowEmailModal(false);
                    getUserData(email);
                }
                else if (res.data === 'already-validated') {
                    setFirstModalLoading(false);
                    setShowUserDetailModal(true);
                    setShowEmailModal(false);
                    getUserData(email);
                }
                else {
                    setFirstModalLoading(false);
                    swal({
                        title: "Unable To Regiseter Email!",
                        icon: 'warning',
                        button: 'OK',
                    });
                }
            })
            .catch(err => {

                setFirstModalLoading(false);
            })

        // handleCloseEmailModal();
    };

    const handleActsStudentEmailRegister = async () => {
        setSecondModalLoading(true);
        service.registerationtokenVerification(email, OTP)
            .then(res => {

                if (res.data === "Success") {
                    handleUserDetailsSubmit();
                }
                else if (res.data === 'already-validated') {

                    handleUserDetailsSubmit();

                } else {
                    setSecondModalLoading(false);
                    swal({
                        title: "Verify Your OTP or Email!",
                        icon: 'warning',
                        button: 'OK',
                    });
                }
            })
            .catch(err => {

                setSecondModalLoading(false);
            })
        // handleCloseEmailModal();
    };

    const encodeUrlHandler = (email, selectedCard) => {

        const secretKey = "cdac@123";

        const encodedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
        const safeEncodedEmail = encodedEmail
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedSelectedCard = CryptoJS.AES.encrypt(selectedCard.toString(), secretKey).toString();
        const safeEncodedSelectedCard = encodedSelectedCard
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        history.push(`${process.env.PUBLIC_URL}/registration-table/${safeEncodedEmail}/${safeEncodedSelectedCard}`);
        // history.push(`${process.env.PUBLIC_URL + "/registration-table/"}${email}/${selectedCard}`);
    };


    const handleUserDetailsSubmit = async () => {
        setSecondModalLoading(true);
        const userDetailFormData = new FormData();
        userDetailFormData.append("firstName", firstName);
        userDetailFormData.append("lastName", lastName);
        userDetailFormData.append("mobile", mobileNumber);
        userDetailFormData.append("email", email);


        service.Register(userDetailFormData)
            .then(res => {

                setSecondModalLoading(false);
                encodeUrlHandler(email, selectedCard)
                // history.push(`${process.env.PUBLIC_URL + "/registration-table/"}${email}/${selectedCard}`);

                // history.push({
                //     pathname: '/registration-table', // Replace '/another-component' with the desired path
                //     state: {
                //         userDetails: userDetails,
                //         selectedCard: selectedCard,
                //     }// Pass userDetails as state
                // });
            })
            .catch(err => {

                setSecondModalLoading(false);
            })
    }

    const getUserData = (email) => {
        service.getUserByEmail(email).then((resp) => {
            setFirstName(resp.data.firstName);
            setLastName(resp.data.lastName);
            setMobileNumber(resp.data.mobile);
        }).catch((err) => {

        })
    }

    const fetchStudentByRoll = (roll) => {
        setFirstModalLoading(true);
        service
            .getActsStudentbyRoll(roll)
            .then((resp) => {

                if (resp.data) {
                    setFirstModalLoading(false);
                    setEmail(resp.data.email);
                    setFirstName(resp.data.firstName);
                    setLastName(resp.data.lastName);
                    setMobileNumber(resp.data.mobile);
                    setRollNumber(resp.data.rollNo);
                    setShowUserDetailModal(true);
                    setShowEmailModal(false);
                }
                else if (resp.data == "") {
                    setFirstModalLoading(false);
                    swal({
                        title: "Roll Number Not Found",
                        icon: 'warning',
                        button: 'OK',
                    });
                }
            })
            .catch((err) => {
                setFirstModalLoading(false);

            });
    };

    const handleRollRegister = () => {

        fetchStudentByRoll(rollNumber);
    };


    return (
        <Styles>
            <section className="registration-page">
                <HeaderTwo />
                <BreadcrumbBox2 title="Registration" />

                <section className="registration-area">
                    <Col className="registration-box">
                        <header className="registration-heading text-center">
                            <h4>Select Registration Type </h4>
                        </header>
                        <Row className="box-row">
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "1" ? "selected" : ""
                                        }`}
                                    id="1"
                                    onClick={(e) => handleCardClick("1")}
                                >
                                    <div className="box-heading">
                                        <h3>Individual User</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/Individual.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>Hands-on, Mentor and Blend courses</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "2" ? "selected" : ""
                                        }`}
                                    id="2"
                                    onClick={(e) => handleCardClick("2")}
                                >
                                    <div className="box-heading">
                                        <h3>Bulk Registrations</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/Bulk Registrations.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            Bulk Registrations (for Hands-on, Mentor and Blend
                                            courses)
                                        </p>
                                        {/* <p>
                                            Minimum 5 users, course fee is <span>Rs. 750/user</span>
                                        </p>
                                        <p>
                                            Minimum 10 users, course fee is <span>Rs. 500/user</span>
                                        </p> */}
                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "3" ? "selected" : ""
                                        }`}
                                    id="3"
                                    onClick={(e) => handleCardClick("3")}
                                >
                                    <div className="box-heading">
                                        <h3>College/University</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/CollegeUniversity.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            Colleges/Universities can upload Excel template (Hands-on, Mentor and Blend courses)
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "4" ? "selected" : ""
                                        }`}
                                    id="4"
                                    onClick={(e) => handleCardClick("4")}
                                >
                                    <div className="box-heading">
                                        <h3>C-DAC ACTS Student</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/C-DAC ACTS Student.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            Hands-on, Mentor and Blend courses for C-DAC
                                            ACTS student
                                        </p>

                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "5" ? "selected" : ""
                                        }`}
                                    id="5"
                                    onClick={(e) => handleCardClick("5")}
                                >
                                    <div className="box-heading">
                                        <h3>C-DAC Employee</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/C-DAC Employee.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            Hands-on, Mentor and Blend courses for C-DAC
                                            employee
                                        </p>

                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "6" ? "selected" : ""
                                        }`}
                                    id="6"
                                    onClick={(e) => handleCardClick("6")}
                                >
                                    <div className="box-heading">
                                        <h3>Corporate Users</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/Corporate Users.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            Corporate users can upload Excel template (Hands-on, Mentor and Blend courses)
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3">
                                <div
                                    className={`selection-box ${selectedCard === "7" ? "selected" : ""
                                        }`}
                                    id="7"
                                    onClick={(e) => handleCardClick("7")}
                                >
                                    <div className="box-heading">
                                        <h3>APSSDC Student</h3>
                                    </div>
                                    <div className="checkmark-icon">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/check.png`
                                            }
                                            alt="check"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    <div className="box-logo">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                `/assets/images/registration-logos/APSSDC Student.png`
                                            }
                                            alt="Logo"
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                    <div className="box-subtitle">
                                        <p>
                                            User accounts will be verified after course enrollment (Hands-on, Mentor and Blend courses)
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="box-info-area">
                            {/* <Col className="info-col">
                                <div className="box-info">
                                    <p>
                                        Course fee for SDR 101 (Wireless Communications using
                                        Software Defined Radio) is <span>Rs. 500</span>
                                    </p>
                                    <p>Course fee for Software Security are : </p>
                                    <p>
                                        Course Access + Completion Certificate is{" "}
                                        <span>Rs 399 (Inclusive of Taxes)</span>{" "}
                                    </p>
                                    <p>
                                        Course Access + Completion on Certificate + Certified
                                        Professional Certificate is{" "}
                                        <span>Rs 999 (Inclusive of Taxes)</span>
                                    </p>
                                </div>
                            </Col> */}
                            {/* <Col className='next-button-col'>
                                <Link to="/registration-verification" state={selectedCard}><Button disabled={selectedCard ? false : true} className='next-button'>Next</Button></Link>
                            </Col> */}
                        </Row>
                    </Col>
                </section>

                <section className="email-modal-area">
                    <Modal
                        backdrop="static"
                        show={showEmailModal}
                        centered
                        onHide={handleCloseEmailModal}
                        size="xl"
                        // dialogClassName="modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {
                                    RegisterType.find((register) => register.id === selectedCard)
                                        ?.type
                                }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(selectedCard == 1 ||
                                selectedCard == 3 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <div>
                                        <Row className="mb-2">
                                            <Col>
                                                <FormStyles>
                                                    <Form.Group controlId="email">
                                                        <Form.Label>Email: </Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder="Enter your email"
                                                            value={email}
                                                            onChange={handleEmailChange}
                                                            onBlur={handleEmailBlur}
                                                            isInvalid={emailError}
                                                        />
                                                        {emailError &&
                                                            // <span className='text-danger p-2' >{emailError}</span>
                                                            <div class="alert alert-danger m-1" role="alert">
                                                                {emailError}
                                                            </div>
                                                        }
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="captcha">
                                                        <Form.Label>Captcha: </Form.Label>
                                                        <div className="captcha-container">
                                                            <img
                                                                src={`data:image/jpeg;base64,${captchaImage}`}
                                                                style={{ height: "50px" }}
                                                                alt="Captcha"
                                                                className="captcha-image"
                                                            />
                                                            <Button
                                                                variant="primary"
                                                                className="refresh-button"
                                                                onClick={handleRefreshCaptcha}
                                                            >
                                                                <i class="fa fa-refresh"></i>
                                                            </Button>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter captcha"
                                                                value={captchaInput}
                                                                onChange={handleCaptchaInputChange}
                                                                className="captcha-input"
                                                                onBlur={handleCaptchaBlur}
                                                                isInvalid={captchaInputError}
                                                            />
                                                            {captchaInputError && <Alert className='error-message ml-1 mt-3' variant="danger">{captchaInputError}</Alert>}
                                                        </div>
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="otp">
                                                        <Form.Label>OTP: </Form.Label>
                                                        <div className="otp-container">
                                                            <Button
                                                                variant="primary"
                                                                onClick={handleSendOTP}
                                                                className="send-otp-button"
                                                                disabled={!email || emailError}
                                                            >
                                                                {otpLoading ? <span class="spinner-border spinner-border-sm"></span> : "Send OTP"}
                                                                {/* Send OTP */}
                                                            </Button>
                                                            {(sendOTP) && (<Form.Control
                                                                type="text"
                                                                placeholder="Enter OTP"
                                                                value={OTP}
                                                                onChange={handleOTPChange}
                                                                onBlur={handleOTPBlur}
                                                                className="otp-input"
                                                                disabled={!sendOTP}
                                                                isInvalid={otpError}
                                                            />)}
                                                            {otpError && <Alert className='error-message ml-1 mt-3' variant="danger">{otpError}</Alert>}
                                                        </div>
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            {selectedCard == 2 && <div></div>}
                            {selectedCard == 4 && (
                                <div>
                                    <FormStyles>
                                        <Form.Group controlId="rollNumber">
                                            <Form.Label>Roll Number: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder={`Enter your roll number`}
                                                value={rollNumber}
                                                onChange={handleRollNumberChange}
                                                onBlur={handleRollNumberBlur}
                                                isInvalid={rollError}
                                            />
                                            {rollError && <Alert className='error-message ml-1 mt-3' variant="danger">{rollError}</Alert>}
                                        </Form.Group>
                                    </FormStyles>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            {(selectedCard == 1 ||
                                selectedCard == 3 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <div>
                                        <Button
                                            variant="success"
                                            onClick={handleEmailRegister}
                                            disabled={emailError || otpError || captchaInputError || !email || !captchaInput || !OTP || firstModalLoading}
                                        >
                                            {firstModalLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Verify OTP</>}
                                        </Button>
                                    </div>
                                )}
                            {selectedCard == 4 && (
                                <div>
                                    <Button
                                        variant="success"
                                        onClick={handleRollRegister}
                                        disabled={!rollNumber || rollError || firstModalLoading}
                                    >
                                        {firstModalLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Verify Roll Number</>}
                                    </Button>
                                </div>
                            )}
                        </Modal.Footer>
                    </Modal>
                </section>

                <section className="userDetails-modal-area">
                    <Modal
                        backdrop="static"
                        show={showUserDetailModal}
                        centered
                        onHide={handleCloseUserDetailModal}
                        size="xl"
                        dialogClassName="modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {
                                    RegisterType.find((register) => register.id === selectedCard)
                                        ?.type
                                }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(selectedCard == 1 ||
                                selectedCard == 3 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <div>
                                        <Row className="mb-2">
                                            <Col>
                                                <FormStyles>
                                                    <Form.Group controlId="email">
                                                        <Form.Label>Email: </Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder="Enter your email"
                                                            value={email}
                                                            onChange={handleEmailChange}
                                                            onBlur={handleEmailBlur}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="firstName">
                                                        <Form.Label>First Name: </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`Enter your First Name`}
                                                            value={firstName}
                                                            onChange={handleFirstNameChange}
                                                            onBlur={handleFirstNameBlur}
                                                            isInvalid={firstNameError}
                                                        />
                                                        {firstNameError && <Alert className='error-message ml-1 mt-3' variant="danger">{firstNameError}</Alert>}
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="Lastname">
                                                        <Form.Label>Last Name: </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`Enter your Lastname`}
                                                            value={lastName}
                                                            onChange={handleLastNameChange}
                                                            onBlur={handleLastNameBlur}
                                                            isInvalid={lastNameError}
                                                        />
                                                        {lastNameError && <Alert className='error-message ml-1 mt-3' variant="danger">{lastNameError}</Alert>}
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col>
                                                <FormStyles>
                                                    <Form.Group controlId="mobileNumber">
                                                        <Form.Label>Mobile Number: </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`Enter your mobile number`}
                                                            value={mobileNumber == null? "Enter your mobile number" : mobileNumber}
                                                            onChange={handleMobileNumberChange}
                                                            onBlur={handleMobileNumberBlur}
                                                            maxLength={10}
                                                            isInvalid={mobileNumberError}
                                                        />
                                                        {mobileNumberError && <Alert className='error-message ml-1 mt-3' variant="danger">{mobileNumberError}</Alert>}
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            {selectedCard == 4 && (
                                <div>
                                    <div>
                                        <Row className="mb-2">
                                            <Col>
                                                <FormStyles>
                                                    <Form.Group controlId="email">
                                                        <Form.Label>Email: </Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder="Enter your email"
                                                            value={email}
                                                            // onChange={handleEmailChange}
                                                            // onBlur={handleEmailBlur}
                                                            // isInvalid={emailError}
                                                            disabled
                                                        />
                                                        {emailError && <Alert className='error-message' variant="danger">{emailError}</Alert>}
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="captcha">
                                                        <Form.Label>Captcha: </Form.Label>
                                                        <div className="captcha-container">
                                                            <img
                                                                src={`data:image/jpeg;base64,${captchaImage}`}
                                                                style={{ height: "50px" }}
                                                                alt="Captcha"
                                                                className="captcha-image"
                                                            />
                                                            <Button
                                                                variant="primary"
                                                                className="refresh-button"
                                                                onClick={handleRefreshCaptcha}
                                                            >
                                                                <i class="fa fa-refresh"></i>
                                                            </Button>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter captcha"
                                                                value={captchaInput}
                                                                onChange={handleCaptchaInputChange}
                                                                className="captcha-input"
                                                                onBlur={handleCaptchaBlur}
                                                                isInvalid={captchaInputError}
                                                            />
                                                            {captchaInputError && <Alert className='error-message ml-1 mt-3' variant="danger">{captchaInputError}</Alert>}
                                                        </div>
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                            <Col lg>
                                                <FormStyles>
                                                    <Form.Group controlId="otp">
                                                        <Form.Label>OTP: </Form.Label>
                                                        <div className="otp-container">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter OTP"
                                                                value={OTP}
                                                                onChange={handleOTPChange}
                                                                onBlur={handleOTPBlur}
                                                                className="otp-input"
                                                                disabled={!sendOTP}
                                                                isInvalid={otpError}
                                                            />
                                                            {otpError && <Alert className='error-message ml-1 mt-3' variant="danger">{otpError}</Alert>}

                                                            <Button
                                                                variant="primary"
                                                                onClick={handleSendOTP}
                                                                className="send-otp-button"
                                                                disabled={!email || emailError || otpLoading}
                                                            >
                                                                {/* {sendOTP ? "SEND OTP AGAIN" : "SEND OTP" } */}
                                                                {otpLoading ? <><span class="spinner-border spinner-border-sm"></span></> : <>Send OTP</>}
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </FormStyles>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            {(selectedCard == 1 ||
                                selectedCard == 3 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <div>
                                        <Button
                                            variant="success"
                                            onClick={handleUserDetailsSubmit}
                                            disabled={firstNameError || lastNameError || mobileNumberError || !firstName || !lastName || !mobileNumber || secondModalLoading}
                                        >
                                            {secondModalLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Submit</>}
                                        </Button>
                                    </div>
                                )}
                            {selectedCard == 2 && (
                                <div>
                                    {/* <Button variant="success" onClick={handleRegister}>
                                        Submit
                                    </Button> */}
                                </div>
                            )}
                            {selectedCard == 4 && (
                                <div>
                                    <Button
                                        variant="success"
                                        onClick={handleActsStudentEmailRegister}
                                        disabled={emailError || captchaInputError || otpError || !email || !captchaInput || !OTP || secondModalLoading}
                                    >
                                        {secondModalLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Submit</>}
                                    </Button>
                                </div>
                            )}
                        </Modal.Footer>
                    </Modal>
                </section>
            </section>
            <FooterTwo />
        </Styles>
    );
};

export default Register2;



// if (res.data == "Successfully Updated") {
//     swal({
//         title: res.data,
//         icon: 'success',
//         button: 'OK',
//     });
// } else if (res.data == "No Student Found") {
//     swal({
//         title: res.data,
//         icon: 'warning',
//         button: 'OK',
//     });
// } else if (res.data == "Failed to Update") {
//     swal({
//         title: res.data,
//         icon: 'error',
//         button: 'OK',
//     });
// }